import { ArrowRight } from 'lucide-react';
import { type HTMLAttributes } from 'react';

type Link = '_blank' | 'target' | 'self' | 'top';

interface LiItemsProps extends HTMLAttributes<HTMLLIElement> {
	name: string;
	url: string;
	target: Link;
}

export interface ListProps extends HTMLAttributes<HTMLUListElement> {
	listItems: LiItemsProps[];
}

const List = ({ listItems, ...rest }: ListProps) => {
	return (
		<ul
			className='wlcb-flex wlcb-flex-col wlcb-space-y-1 wlcb-items-start wlcb-justify-start'
			{...rest}
		>
			{listItems.map(({ name, url, target, ...liRest }, index) => (
				<li
					className='wlcb-transition-all wlcb-h-10 wlcb-w-[295px] wlcb-border-[1px] wlcb-bg-primary hover:wlcb-bg-primary-hover active:wlcb-bg-primary-pressed focus:wlcb-bg-primary-pressed wlcb-rounded-md '
					key={index}
					{...liRest}
				>
					<a
						className='wlcb-size-full wlcb-p-space-100 wlcb-flex wlcb-items-center wlcb-justify-between wlcb-text-button wlcb-text-white'
						href={url}
						target={target}
					>
						{name}
						<span className='sr-only'>Link: {name}</span>
						<ArrowRight className='wlcb-size-5 wlcb-stroke-white' />
					</a>
				</li>
			))}
		</ul>
	);
};

export default List;
